import api from "../../api";

export const putUserProfile = async (data: {
  name: string;
  region: string;
  age_range: string | null;
  gender: string | null;
  bio: string;
  instagram: string;
  website: string;
  linkedin: string;
  emergency_contact_name: string;
  emergency_contact_phone_number: string;
  address: string;
  address_location: any;
  twitter: string;
  facebook: string;

  skill_level: number | null;
  comp_level: number | null;
  lessons: number | null;
  game_frequency: number | null;
  fitness_level: number | null;
  has_past_racquet_experience: boolean | null;
  form_of_tennis: string | null;
}) => {
  const res = await api.put("member/myprofile/", data);
  return res.data;
};

export const putUserSettings = async (data: {
  email?: string;
  phone_number?: string;
  password?: string;
}) => {
  const res = await api.put("user/edit/", {
    ...data,
    providers_to_delete: ["google.com", "facebook.com", "apple.com"],
  });
  return res.data;
};

export const getNotificationSettings = async () => {
  const res = await api.get("notifications/settings/");
  return res.data;
};

export const patchNotificationSettings = async (data: {
  push_notifications?: any;
  email_notifications?: any;
  email_notifications_enabled?: boolean;
  push_notifications_enabled?: boolean;
  push_notifications_followed_only?: boolean;
  membership_nudges_opt_out?: boolean;
}) => {
  const res = await api.patch("notifications/settings/", data);
  return res.data;
};

export const getPayments = async (data: {
  type: string;
  page: number;
  page_size: number;
  member_id?: string;
}) => {
  const res = await api.get("stripe/list/", { params: data });
  return res.data;
};

export const getWalletPackages = async (data?: any) => {
  const res = await api.get("packages/wallet/", { params: data });
  return res.data;
};

export const getCoachReports = async (data: {
  page: number;
  page_size: number;
  min_date?: string;
}) => {
  const res = await api.get("events/payout_reports/", { params: data });
  return res.data;
};

export const getFinishedEvents = async () => {
  const res = await api.get("events/bookings/");
  return res.data;
};

export const getBankAccount = async () => {
  const res = await api.get("coach/bankaccounts/");
  return res.data;
};

export const getCoachPayouts = async (data: {
  events: string;
  venues: string;
  coaches: string;
  min_date: string;
  max_date: string;
}) => {
  const res = await api.get("events/coach_payouts/", { params: data });
  return res.data;
};

export const getPayouts = async (data: {
  amount: string | null;
  page: number;
  page_size: number;
}) => {
  const res = await api.get("coach/payouts/", { params: data });
  return res.data;
};

export const getTransactions = async (data: {
  period: string;
  prev: string;
  page: number;
  page_size: number;
}) => {
  const res = await api.get("coach/transactions/", { params: data });
  return res.data;
};

export const getTransactionsGraph = async (data: {
  prev: string;
  period: string;
}) => {
  const res = await api.get("coach/transactions/graph/", { params: data });
  return res.data;
};

export const putBankAccount = async (data: {
  account_name: string;
  account_type: string;
  account_number: string;
  routing_number: string;
  country: string;
}) => {
  const res = await api.put("coach/bankaccounts/", data);
  return res.data;
};

export const postReport = async (data: { description: string }) => {
  const res = await api.post("support/report/", data);
  return res.data;
};
